import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import { StudentImage } from '../models';
import { seasonYear } from '../utils/functions';

// `includeSeniorSeasons` defaults to FALSE: senior portraits never belong on a
// past-images screen (Alex, 2026-09-06) -- a senior who already ordered is sent to this
// year's senior pricelist instead. The one page that genuinely needs them, the senior
// Quick Order at /c/senior-past-images-order, opts back in explicitly; it uses the
// senior portrait as its hero and reads the grad year off that folder.
export default function usePastImages({ studentId, additionalQuery = {}, includeSeniorSeasons = false }) {
  const season = localStorage.getItem(`currentSeason-${studentId}`);

  return useQuery({
    queryKey: [QueryKeys.pastImages, season, studentId, includeSeniorSeasons],
    queryFn: () => (
      StudentImage
        .includes('poses')
        .selectExtra(['packageId'])
        .extraParams({ pastImages: true })
        .where({ notSiblingImages: true })
        .where({ studentId })
        .where({ forPastImages: true })
        .where(includeSeniorSeasons ? {} : { excludingSeniorSeasons: true })
        .where(additionalQuery)
        .all()
        .then((res) => {
          if (res.data.length === 0) return [];

          return res
            .data
            .filter((studentImage) => (
              !(studentImage.watermarkUrl || '').includes('missing.png')
            ))
            .sort((a, b) => seasonYear(a.folder) - seasonYear(b.folder));
        })
    ),
    placeholderData: [],
    staleTime: 0,
    enabled: !!studentId,
  });
}
